export function filterOutNulls<T>(obj: T): T {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null)) as T
}
